import { PermissionFeature } from '@shared/const';
import { useHasPermission } from '@shared/hooks';
import { PermissionType } from '@shared/const';
import { useCurrentUser } from '@shared/hooks';
import { PropsWithChildren, FC } from 'react';
import { Navigate } from 'react-router-dom';
import { Role } from '@interfaces/models';

interface HasPermissionProps extends PropsWithChildren {
  permissionFeature: PermissionFeature;
  permissionType: PermissionType;
  redirect?: boolean;
  forRole?: Role;
}

export const HasPermission: FC<HasPermissionProps> = ({
  permissionFeature,
  permissionType,
  children,
  forRole,
  redirect = false,
}) => {
  const hasPermission = useHasPermission(permissionFeature, permissionType, forRole);
  const { companyId, role } = useCurrentUser();
  const userReady = !!role && !!companyId;

  if (!hasPermission) {
    if (redirect && userReady) return <Navigate to={`/${companyId}`} />;
    return null;
  }
  return children;
};
